import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { TmShowLink, TmShowModel, TmWatchUsLiveModel, TmWeeklySchedule } from '../model/show';
import { ApiBase } from './apibase.service';


export class Shows extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(timeZone: string, date: string, timeRange: string): Observable<TmShowModel[]> {
        let urlParams: URLSearchParams = new URLSearchParams();

        if (timeZone != undefined && timeZone.trim().length > 0) urlParams.set('timeZone', timeZone);

        if (date != undefined && date.trim().length > 0) urlParams.set('date', date);

        return this.http
            .get(this.baseUrl + '/shows/daily', { headers: this.cachebleHeaders, search: urlParams })
            .map((r: Response) => r.json() as TmShowModel[]);
    }

    search(timeZone: string, keyWord: string): Observable<TmShowModel[]> {
        let urlParams: URLSearchParams = new URLSearchParams();

        if (timeZone != undefined && timeZone.trim().length > 0) urlParams.set('timeZone', timeZone);

        //fix for Edge and Safari for PBI 5929
        if (keyWord != undefined && keyWord != null) keyWord = keyWord.replace('.+', encodeURIComponent('. '));

        return this.http
            .get(this.baseUrl + '/shows/search?term=' + keyWord, { headers: this.cachebleHeaders, search: urlParams })
            .map((r: Response) => r.json() as TmShowModel[]);
    }

    getWeekly(timeZone: string, date: string): Observable<TmWeeklySchedule> {
        let urlParams: URLSearchParams = new URLSearchParams();

        if (timeZone != undefined && timeZone.trim().length > 0) urlParams.set('timeZone', timeZone);

        if (date != undefined && date.trim().length > 0) urlParams.set('date', date);

        return this.http
            .get(this.baseUrl + '/shows/weekly', { headers: this.cachebleHeaders, search: urlParams })
            .map((r: Response) => r.json() as TmWeeklySchedule);
    }
}(Shows as any).ctorParameters = function () { return [ { type: Http } ]; }


export class ShowLinks extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(): Observable<TmShowLink[]> {
        return this.http
            .get(this.baseUrl + '/shows/today', { headers: this.cachebleHeaders })
            .map((r: Response) => r.json() as TmShowLink[]);
    }
}(ShowLinks as any).ctorParameters = function () { return [ { type: Http } ]; }


export class WatchUsLive extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    get(timeZone: string): Observable<TmWatchUsLiveModel> {
        let urlParams: URLSearchParams = new URLSearchParams();

        if (timeZone != undefined && timeZone.trim().length > 0) urlParams.set('timeZone', timeZone);

        return this.http
            .get(this.baseUrl + '/shows/watchuslive', { headers: this.headers, search: urlParams })
            .map((r: Response) => r.json() as TmWatchUsLiveModel);
    }
}(WatchUsLive as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/show.service.ts